var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.294 12.71a1.002 1.002 0 0 1 0-1.416l-.003-.003 6-6a1.001 1.001 0 0 1 1.415 1.415L13.416 12l5.293 5.294a1.001 1.001 0 0 1-1.415 1.415l-6-6Z",
    fill: "#FCB519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.295 12.71a1.001 1.001 0 0 1 0-1.416l-.003-.003 6-6a1.001 1.001 0 0 1 1.416 1.415L7.418 12l5.293 5.294a1.001 1.001 0 0 1-1.416 1.415l-6-6Z",
    fill: "#FCB519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowIcon);
export default __webpack_public_path__ + "static/media/double-arrow-icon.8f91c8ec471c14379284d9ccdbc1c867.svg";
export { ForwardRef as ReactComponent };